import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Phone, ArrowRight } from "lucide-react";
import { WHATSAPP_URL } from "./data";
import { scrollToSection } from "@/lib/scrollTo";

export const StickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.4, ease: [0.33, 1, 0.68, 1] }}
          className="fixed inset-x-0 bottom-0 z-[80] border-t border-[#D4AF37]/25 bg-white/92 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl lg:hidden"
          data-testid="sticky-cta-bar"
        >
          <div className="grid grid-cols-3 gap-px bg-[#D4AF37]/15">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sticky-cta-whatsapp"
              className="flex flex-col items-center gap-1 bg-white py-3 text-[#A07E1F]"
            >
              <MessageCircle size={19} />
              <span className="font-mono-accent text-[9px] uppercase tracking-[0.15em]">WhatsApp</span>
            </a>
            <a
              href="tel:+442073626786"
              data-testid="sticky-cta-call"
              className="flex flex-col items-center gap-1 bg-white py-3 text-[#46586F]"
            >
              <Phone size={19} />
              <span className="font-mono-accent text-[9px] uppercase tracking-[0.15em]">Call Us</span>
            </a>
            <button
              onClick={() => scrollToSection("#quote")}
              data-testid="sticky-cta-quote"
              className="flex flex-col items-center gap-1 bg-[#D4AF37] py-3 text-[#0A1E3C]"
            >
              <ArrowRight size={19} />
              <span className="font-mono-accent text-[9px] font-bold uppercase tracking-[0.15em]">Free Quote</span>
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
